var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"viewBox":"0 0 24 24"},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('use',_vm._b({},'use',{ 'xlink:href': `${_setup.iconSvg}#${_vm.name}` },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }